import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
}
const Button = ({
  children,
  variant = 'primary',
  onClick,
  fullWidth = false,
  type = 'button'
}: ButtonProps) => {
  const baseClasses = 'min-h-[44px] px-4 py-2 font-medium rounded-xl text-center transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantClasses = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
    secondary: 'bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 focus:ring-blue-500'
  };
  return <button type={type} className={`${baseClasses} ${variantClasses[variant]} ${fullWidth ? 'w-full' : ''}`} onClick={onClick} data-id="element-19">
      {children}
    </button>;
};
export default Button;